import Analytics from '@mysidewalk/analytics';

import { SEGMENT_API_KEY, PROTOCOL, API_DOMAIN } from '../settings';

Analytics.configure({ domain: API_DOMAIN, protocol: PROTOCOL });
const analyticsManager = new Analytics({ apiKey: SEGMENT_API_KEY });
export default analyticsManager;

export function trackEvent(event, props = {}) {
  analyticsManager.event(
    event,
    {
      // Raise visibility of product & page
      url: window.location.href,
      product: 'Catalog',
      ...props,
    },
  );
}
